export const liveSessionId = [123, 122, 121];
export const API_URL = 'https://api.myedusolvex.com/api';
export const KPJ_CODE_ADMIN = 'mesxinternalcodeaccess';
